import axios from "axios";
import API from "../api";

export const GuestNotesModule = {
  state: {
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    getGuestNotes({
      commit
    }, guestId) {
      return new Promise(async (resolve, reject) => {
        commit("getGuestNotesRequest");
        return axios
          .get(`${API.BASE_URL}${API.GUESTS}/${guestId}${API.NOTES}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getGuestNotesSuccess", response.data);
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("guestNoteError", error);
            reject(error);
          });
      });
    },
    createGuestNote({
      commit
    }, record) {
      return new Promise(async (resolve, reject) => {
        commit("createGuestNoteRequest");
        return axios
          .post(`${API.BASE_URL}${API.GUESTS}${API.NOTES}`, record, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit("createGuestNoteSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("guestNoteError", error);
            reject(error);
          });
      });
    },
    deleteGuestNote({
      commit
    }, recordId) {
      return new Promise(async (resolve, reject) => {
        commit("deleteGuestNoteRequest");
        return axios
          .delete(`${API.BASE_URL}${API.GUESTS}${API.NOTES}/${recordId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("deleteGuestNoteSuccess", recordId);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("guestNoteError", error);
            reject(error);
          });
      });
    }
  },
  mutations: {
    getGuestNotesRequest(state) {
      state.isRequesting = true;
    },
    getGuestNotesSuccess(state, payload) {
      state.isRequesting = false;
    },
    createGuestNoteRequest(state) {
      state.isRequesting = true;
    },
    createGuestNoteSuccess(state, payload) {
      state.isRequesting = false;
    },
    guestNoteError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    deleteGuestNoteRequest(state) {
      state.isRequesting = true;
    },
    deleteGuestNoteSuccess(state, recordId) {
      state.isRequesting = false;
    }
  }
};